// ========== 2D Perlin 噪声生成器 ==========
class NoiseGenerator {
    constructor(seed = 42) {
        this.perm = [];
        this.gradients = [];
        this.initNoise(seed);
    }

    initNoise(seed) {
        const p = [];
        for (let i = 0; i < 256; i++) p.push(i);
        
        // 用 seed 打乱
        for (let i = 255; i > 0; i--) {
            const j = Math.floor(((seed + i * 31) & 0x7fffffff) % (i + 1));
            [p[i], p[j]] = [p[j], p[i]];
        }
        
        for (let i = 0; i < 512; i++) {
            this.perm[i] = p[i & 255];
        }
        
        // 预计算梯度方向
        for (let i = 0; i < 256; i++) {
            const angle = p[i] * 2 * Math.PI / 256;
            this.gradients[i] = { 
                x: Math.cos(angle), 
                y: Math.sin(angle) 
            };
        }
    }

    fade(t) { 
        return t * t * t * (t * (t * 6 - 15) + 10); 
    }

    lerp(a, b, t) { 
        return a + t * (b - a); 
    }

    dotGrad(hash, x, y) {
        const g = this.gradients[hash & 255];
        return g.x * x + g.y * y;
    }

    noise2D(x, y) {
        const X = Math.floor(x) & 255;
        const Y = Math.floor(y) & 255;
        const xf = x - Math.floor(x);
        const yf = y - Math.floor(y);
        const u = this.fade(xf);
        const v = this.fade(yf);
        
        const aa = this.perm[this.perm[X] + Y];
        const ab = this.perm[this.perm[X] + Y + 1];
        const ba = this.perm[this.perm[X] + 1 + Y];
        const bb = this.perm[this.perm[X + 1] + Y + 1];
        
        const x1 = this.lerp(
            this.dotGrad(aa, xf, yf), 
            this.dotGrad(ba, xf - 1, yf), 
            u
        );
        const x2 = this.lerp(
            this.dotGrad(ab, xf, yf - 1), 
            this.dotGrad(bb, xf - 1, yf - 1), 
            u
        );
        
        return this.lerp(x1, x2, v);
    }

    // 分形布朗运动 (FBM) - 叠加多层噪声
    fbm(x, y, octaves = 2, lacunarity = 2.0, gain = 0.5) {
        let value = 0;
        let amplitude = 1;
        let frequency = 1;
        let maxVal = 0;
        
        // 限制最多2层噪声（性能优化）
        for (let i = 0; i < Math.min(octaves, 2); i++) {
            value += amplitude * this.noise2D(x * frequency, y * frequency);
            maxVal += amplitude;
            amplitude *= gain;
            frequency *= lacunarity;
        }
        
        return value / maxVal; // 归一化到 [-1, 1]
    }
}

export default NoiseGenerator;
